module.exports = __webpack_public_path__ + "static/media/post_4000.568d0405.glb";